// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__4nTEm","title":"FrontImage_title__2e9AN"};